module.exports = __webpack_public_path__ + "media/images/lb/388-6f63d0ebb6442ae75430500c20c66469.svg";